var map = {
	"./acaademForm.json": 5024,
	"./academ.json": 61194,
	"./accounting.json": 24589,
	"./admin.json": 87783,
	"./adminPage.json": 36176,
	"./archive.json": 59477,
	"./assignments.json": 14057,
	"./auth.json": 70941,
	"./auto.json": 38571,
	"./calendar.json": 47282,
	"./career.json": 61920,
	"./chat.json": 57920,
	"./chatForm.json": 22574,
	"./collective.json": 60256,
	"./common.json": 37827,
	"./components.json": 7514,
	"./dashboard.json": 77744,
	"./deanDash.json": 82425,
	"./diploma.json": 78240,
	"./distance.json": 30366,
	"./dorm.json": 96733,
	"./dpo.json": 32676,
	"./employees.json": 55683,
	"./europass.json": 8999,
	"./foreign.json": 21963,
	"./forms.json": 9479,
	"./gradebook.json": 91291,
	"./groups.json": 20914,
	"./help.json": 88079,
	"./helpPage.json": 31515,
	"./helpers.json": 18605,
	"./hooks.json": 3736,
	"./integrations.json": 74885,
	"./journal.json": 94935,
	"./kanban.json": 22187,
	"./lang.json": 44435,
	"./library.json": 8281,
	"./loginPage.json": 37141,
	"./main.json": 91775,
	"./menu.json": 21134,
	"./menuDrawer.json": 13022,
	"./military.json": 30724,
	"./noMatch.json": 24126,
	"./notes.json": 31530,
	"./notification.json": 33238,
	"./orderForm.json": 68283,
	"./orders.json": 34846,
	"./ordersPage.json": 73442,
	"./pages.json": 6151,
	"./plagiarism.json": 24929,
	"./postgrad.json": 10939,
	"./practice.json": 78885,
	"./profile.json": 48300,
	"./profilePage.json": 89001,
	"./qr.json": 92148,
	"./quiz.json": 39531,
	"./quizForm.json": 38540,
	"./report_card.json": 24871,
	"./reports.json": 50883,
	"./schedule.json": 29502,
	"./science.json": 50717,
	"./sessions.json": 92805,
	"./statements.json": 20831,
	"./statementsPage.json": 69961,
	"./statistic.json": 80144,
	"./statisticPage.json": 54192,
	"./structure.json": 68973,
	"./structureForm.json": 18217,
	"./studentDash.json": 62207,
	"./studentLife.json": 48535,
	"./students.json": 52282,
	"./subjectPage.json": 43636,
	"./support.json": 37176,
	"./survey.json": 30328,
	"./surveyForm.json": 32956,
	"./surveys.json": 31651,
	"./syllabus.json": 88830,
	"./taskForm.json": 23308,
	"./taskInfo.json": 84989,
	"./taskItem.json": 2239,
	"./tasks.json": 70011,
	"./tasksPage.json": 22166,
	"./teacherDash.json": 19606,
	"./test.json": 82616,
	"./testForm.json": 92819,
	"./tests.json": 94009,
	"./ui.json": 44861,
	"./user.json": 76681,
	"./utils.json": 70721,
	"./weather.json": 29349,
	"locales/ky/acaademForm.json": 5024,
	"locales/ky/academ.json": 61194,
	"locales/ky/accounting.json": 24589,
	"locales/ky/admin.json": 87783,
	"locales/ky/adminPage.json": 36176,
	"locales/ky/archive.json": 59477,
	"locales/ky/assignments.json": 14057,
	"locales/ky/auth.json": 70941,
	"locales/ky/auto.json": 38571,
	"locales/ky/calendar.json": 47282,
	"locales/ky/career.json": 61920,
	"locales/ky/chat.json": 57920,
	"locales/ky/chatForm.json": 22574,
	"locales/ky/collective.json": 60256,
	"locales/ky/common.json": 37827,
	"locales/ky/components.json": 7514,
	"locales/ky/dashboard.json": 77744,
	"locales/ky/deanDash.json": 82425,
	"locales/ky/diploma.json": 78240,
	"locales/ky/distance.json": 30366,
	"locales/ky/dorm.json": 96733,
	"locales/ky/dpo.json": 32676,
	"locales/ky/employees.json": 55683,
	"locales/ky/europass.json": 8999,
	"locales/ky/foreign.json": 21963,
	"locales/ky/forms.json": 9479,
	"locales/ky/gradebook.json": 91291,
	"locales/ky/groups.json": 20914,
	"locales/ky/help.json": 88079,
	"locales/ky/helpPage.json": 31515,
	"locales/ky/helpers.json": 18605,
	"locales/ky/hooks.json": 3736,
	"locales/ky/integrations.json": 74885,
	"locales/ky/journal.json": 94935,
	"locales/ky/kanban.json": 22187,
	"locales/ky/lang.json": 44435,
	"locales/ky/library.json": 8281,
	"locales/ky/loginPage.json": 37141,
	"locales/ky/main.json": 91775,
	"locales/ky/menu.json": 21134,
	"locales/ky/menuDrawer.json": 13022,
	"locales/ky/military.json": 30724,
	"locales/ky/noMatch.json": 24126,
	"locales/ky/notes.json": 31530,
	"locales/ky/notification.json": 33238,
	"locales/ky/orderForm.json": 68283,
	"locales/ky/orders.json": 34846,
	"locales/ky/ordersPage.json": 73442,
	"locales/ky/pages.json": 6151,
	"locales/ky/plagiarism.json": 24929,
	"locales/ky/postgrad.json": 10939,
	"locales/ky/practice.json": 78885,
	"locales/ky/profile.json": 48300,
	"locales/ky/profilePage.json": 89001,
	"locales/ky/qr.json": 92148,
	"locales/ky/quiz.json": 39531,
	"locales/ky/quizForm.json": 38540,
	"locales/ky/report_card.json": 24871,
	"locales/ky/reports.json": 50883,
	"locales/ky/schedule.json": 29502,
	"locales/ky/science.json": 50717,
	"locales/ky/sessions.json": 92805,
	"locales/ky/statements.json": 20831,
	"locales/ky/statementsPage.json": 69961,
	"locales/ky/statistic.json": 80144,
	"locales/ky/statisticPage.json": 54192,
	"locales/ky/structure.json": 68973,
	"locales/ky/structureForm.json": 18217,
	"locales/ky/studentDash.json": 62207,
	"locales/ky/studentLife.json": 48535,
	"locales/ky/students.json": 52282,
	"locales/ky/subjectPage.json": 43636,
	"locales/ky/support.json": 37176,
	"locales/ky/survey.json": 30328,
	"locales/ky/surveyForm.json": 32956,
	"locales/ky/surveys.json": 31651,
	"locales/ky/syllabus.json": 88830,
	"locales/ky/taskForm.json": 23308,
	"locales/ky/taskInfo.json": 84989,
	"locales/ky/taskItem.json": 2239,
	"locales/ky/tasks.json": 70011,
	"locales/ky/tasksPage.json": 22166,
	"locales/ky/teacherDash.json": 19606,
	"locales/ky/test.json": 82616,
	"locales/ky/testForm.json": 92819,
	"locales/ky/tests.json": 94009,
	"locales/ky/ui.json": 44861,
	"locales/ky/user.json": 76681,
	"locales/ky/utils.json": 70721,
	"locales/ky/weather.json": 29349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5993;